//------------- HOME ---------

//nessa página será necessário:
// - substituir o link do dashboard quando o mesmo estiver finalizado
// - implementar o "Ultimas inspeções" no botão histório
//      que irá exibir as últimas inspeções realizadas pelos técnicos
// - ajustar o estilo dos botões do "header", para que fique mais intuitivo que página está sendo mostrada

//apague esses comentarios quando terminar as tarefas kkkkkk

//importações
import React from "react";
import { useState } from "react";
import "./styles.css";

import formatDate from "../../utils/functions/formatDate";

//icons
import { VscPieChart } from "react-icons/vsc";
import { VscHistory } from "react-icons/vsc";

import MenuNavigator from "../../components/menu-navigator";
import ButtonMenu from "../../components/btn-menu";

import handleProfilePic from "../../utils/functions/profilePic";

const Home = ({ token = JSON.parse(sessionStorage.getItem("token")) }) => {
    //carrega o usuário da sessão
    const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("user")));

    //verifica qual página está sendo exibida
    const [pageContent, setPageContent] = useState(0);

    //vetor de botões do header
    //insira aqui algum novo botão caso necessário
    const headerButtons = [
        { nome: "Indicadores", icone: <VscPieChart /> },
        // { nome: "Histórico", icone: <VscHistory /> },
        // { nome: "", icone: <></> },
    ];

    //gerencia o que será exibido em cada página selecionada no header
    const handlePageContent = () => {
        switch (pageContent) {
            //dashboard
            //substitua o link do dash quando o memso for concluido
            case 0:
                return (
                    <iframe
                        className="iframe-dashboard"
                        title="dash-bi"
                        //exemplo de dash
                        src="https://app.powerbi.com/view?r=eyJrIjoiYWNkMWEyMjctM2NhMS00YjUyLWJkODgtYWY2Yzk2NzNiODk5IiwidCI6ImJhMzg5NTgyLTA0M2ItNDBhYS04ZWJlLWNmYjBhZTI4MjgzMyJ9"
                    ></iframe>
                );
            //últimas inspeções
            //aqui será inserido um datagrid com as ultimas inspeções realizadas
            case 1:
                return <p>{""}</p>;

            default:
                break;
        }
    };

    //VIEW DA PÁGINA
    const handleViewComponent = () => {
        return (
            <div className="div-body-home-component">
                {/* header onde ficam os botões e a saudação ao do usuário */}
                <div className="div-header" id="menu-sup">
                    <div>
                        <div className="profile-icon" id="header-profile-icon">
                            <p>{handleProfilePic(user)}</p>
                        </div>
                        <div className="header-text">
                            {user && (
                                <p className="name">
                                    {formatDate(new Date()).saudacao +
                                        ", " +
                                        user.nome.split(" ")[0] +
                                        "!"}
                                </p>
                            )}
                            <p className="date">{formatDate(new Date()).data}</p>
                        </div>
                    </div>
                    <div id="buttons">
                        {headerButtons.map((element, i) => {
                            return (
                                <div
                                    className={pageContent === i ? "button-content-selected" : ""}
                                    key={"btnHeader-" + i}
                                    onClick={() => setPageContent(i)}
                                >
                                    <div className={"button-content"}>
                                        {element.icone}
                                        {element.nome}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* menu de botões coloridos */}
                <div id="home-content">
                    <div className="div-services">
                        <p>Serviços</p>
                        <div className="detail-bar">{"."}</div>
                        <div className="div-buttons">
                            <ButtonMenu
                                bgColor={"#C96D19"}
                                text="Programe rotas de inspeções dos técnicos"
                                title="AGENDA"
                                icon="agenda"
                            ></ButtonMenu>
                             <ButtonMenu
                                bgColor={"#6B8A22"}
                                text="Cadastre e analise as inspeções de técnicos"
                                title="TÉCNICOS"
                                icon="tecnicos"
                            ></ButtonMenu>
                        </div>
                        <div className="div-buttons">
                            <ButtonMenu
                                bgColor={"#A14111"}
                                text="Veja as rotas feitas pelos técnicos"
                                title="MAPA"
                                icon="mapa"
                            ></ButtonMenu>
                            <ButtonMenu
                                bgColor={"#126E66"}
                                text="Veja as inpeções realizadas pelos técnicos"
                                title="REALIZADOS"
                                icon="realizados"
                            ></ButtonMenu>
                        </div>
                    </div>
                    {/* exibe o conteudo da página selecionada */}
                    <div className="div-content">{handlePageContent()}</div>
                </div>
            </div>
        );
    };

    //ENVIA A VIEW DA PÁGINA PARA O COMPONENT NAVIGATOR
    return <MenuNavigator token={token} page="/home" view={handleViewComponent()}></MenuNavigator>;
};

export default Home;
